module.exports = __webpack_public_path__ + "static/scale-model-of-yonkers-new-york-b7bbc9717cc0378c669b9256cce5cc6b.png";